<template>
   <section class="gurantee-full-wrap new-full-about strong-section p-0">
        <div class="barana-img"><img alt="" class="w-100" src="/assets/images/new_home/Univie-Image1.jpg"></div>
        <div class="barana-text">
            <div class="container">
                <div class="row ">
                    <div class="col-md-12 ms-md-auto aos-init aos-animate" data-aos="fade-right">
                    <h2>Why UneVie® Works When Plain Water Doesn’t</h2>

                    <p>Regular water often passes right through you—only a small percentage is absorbed at the cellular level. <b>UneVie® uses structured water technology </b> to deeply hydrate your cells—<b>up to 10x more effectively than drinking plain water</b>.</p>
                    <p><b>Deep Cellular Hydration </b> UneVie® penetrates cell membranes to hydrate from the inside out—supporting energy, focus, and smooth digestion.</p>

                    <p><b>Supports Metabolism &amp; Detox</b> When your cells are properly hydrated, they function better—improving detox pathways and metabolic health.</p>

                    <p><b>Promotes Healthier Aging </b> Hydrated cells mean healthier skin, better joint function, and reduced oxidative stress—key to feeling youthful longer.</p>

                    <p><b>Feel More Energized, More Alive</b> Better hydration means better nutrient absorption, better focus, and better stamina—without extra caffeine or sugar.</p>

                    <p>Our foundational product, UneVie®, is world’s first structured water solution that works at cellular level in your body. Proven to get deep into cells to increase the water level and support cellular longevity, metabolism, healthier aging, and sustained energy.</p>

                    
                    </div>
                </div>

            </div>
        </div>
    </section>
    <section class="products-related-gsh complex-sec2">
        <div class="container-fluid">
            <div class="row" data-aos="fade-up">
                <div class="col-md-6 mb-4 mb-md-0"><img src="/assets/images/new_home/Univie-Image2.jpg" alt=""></div>
                <div class="col-md-6">
                    <h2>UneVie® </h2>
                    <h3>Cellular Hydrating Solution</h3>
                    <p>UneVie is a structured water produced through a proprietary technology using excitation currents as well as quarts wavelength technology purification process for a unique proprietary structure. It acts as a highly efficient "delivery system" with powerful hydrating and restorative properties that transport vital nutrients to every cell in your body. Healthier than sugar-rich sports drinks and highly caffeinated energy drinks, UNE VIE hydrates more effectively than drinking 10 glasses of water.</p>
                </div>
            </div>
        </div>
    </section>
  </template>
  
  <script setup>
  import { ref, computed, defineProps, onUpdated, onMounted } from "vue";
  import { useLoginStore } from "../../stores/login";
  import { useCartStore } from "../../stores/cart";
  import { userLanguage } from "../../stores/language";
  import { onBeforeRouteLeave, onBeforeRouteUpdate } from "vue-router";
  import $ from "jquery";
  const userLogin = useLoginStore();
  const cartData = useCartStore();
  const userLanguages = userLanguage();
  const token = ref("");
  const props = defineProps(["baseURL", "translationText"]);
  const siteFooterLegal = ref([]);
  const defaultLanguage = ref("");
  
  onMounted(() => {  
  });
  
  onUpdated(() => {});
  </script>